module.exports = __webpack_public_path__ + "img/36-SportsCapital.32f55d63.jpg";